export const aboutData = {
  title: "Who I am",
  description1: `My name's Anuj.
    I'm a Kotlin Multiplatform (android,ios)developer based in India`,
  description2:
    "I have worked as a lead developer at a mounty.co and internationalschooling.org full time. In terms of architecture i have worked on varioush different architecture. I spent my leisure hours writing articles. Right now I'm also trying a hand at jecpack compose and KMM. I love to learn and explore new areas.",
  image: 2,
};
